module.exports = __webpack_public_path__ + "static/media/1995.48ac4eb5.svg";